import { useSyncExternalStore } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getPreferredScrollBehavior } from '@/utils/motion';

function subscribeToWindowScroll(onScrollChange: () => void): () => void {
  window.addEventListener('scroll', onScrollChange, { passive: true });
  window.addEventListener('resize', onScrollChange);
  return () => {
    window.removeEventListener('scroll', onScrollChange);
    window.removeEventListener('resize', onScrollChange);
  };
}

const isScrolledPastFirstScreen = (): boolean => window.scrollY > window.innerHeight;

function scrollWindowToTop() {
  window.scrollTo({ top: 0, behavior: getPreferredScrollBehavior() });
}

export function ScrollToTopButton() {
  const isVisible = useSyncExternalStore(subscribeToWindowScroll, isScrolledPastFirstScreen);

  return (
    <button
      type="button"
      onClick={scrollWindowToTop}
      aria-label="Back to top"
      inert={!isVisible}
      className={cn(
        'fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom))] z-40 flex size-9 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg ring-3 ring-primary/20 transition-[opacity,translate] duration-200 active:bg-primary/90 lg:hidden',
        isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2 opacity-0',
      )}
    >
      <ArrowUp className="size-4" aria-hidden />
    </button>
  );
}
